import { Truck, Leaf, Coffee } from "lucide-react";

export default function AnnouncementBar() {
  return (
    <div className="bg-[#557149] text-white text-sm">
      <div className="max-w-7xl mx-auto px-6">

        <div className="flex items-center justify-center gap-8 h-10">

          <div className="flex items-center gap-2">
            <Truck size={15}/>
            <span>Free Shipping over $80</span>
          </div>

          <div className="hidden md:flex items-center gap-2">
            <Leaf size={15}/>
            <span>Sustainably Curated</span>
          </div>

          <div className="hidden lg:flex items-center gap-2">
            <Coffee size={15}/>
            <span>Fresh Coffee Roasted Weekly</span>
          </div>

        </div>

      </div>
    </div>
  );
}